import url from './url';

async function getCaptcha() {
  const response = await fetch(`${url}/captcha`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'get',
  });

  if (!response.ok) {
    throw new Error('Não foi possível carregar o código de verificação.');
  }

  return response.json();
}

export { getCaptcha };
